import axios from 'axios'
import store from './store/store'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
})

axiosInstance.interceptors.request.use((axiosConfig) => {
  if (typeof store.getState().user.current_user !== 'undefined') {
    const user_token = store.getState().user.current_user.authentication_token
    if (user_token) {
      axiosConfig.headers.Authorization = `${user_token}`
    }
  }

  return axiosConfig
})

axiosInstance.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response && (typeof error.response.data.errors === 'string' || error.response.data.errors instanceof String)) {
      error.response.data.errors = { general: [error.response.data.errors] }
    } else if (!error.response || error.response.status === 500) {
      error.response = {
        data: {
          errors: { general: ['Something went wrong, please try again'] },
        },
      }
    } else if (error.response.status === 503) {
      const message = error.response.data?.message || 'This feature is currently unavailable.'
      error.response.data = {
        errors: { general: [message] },
      }
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
